var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.view},[(_vm.$q.platform.is.desktop)?_c('h5',{staticClass:"text-grey-1 text-bold"},[_vm._v("Resultaten")]):_vm._e(),_vm._l((_vm.splitResults),function(result){return _c('result',{class:_vm.resultClass,attrs:{"result-text":result}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }